import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Y2021RoutingModule } from './y2021-routing.module';
import { Y2021Component } from './y2021.component';
import { EventSharedModule } from '../components/event-shared.module';


@NgModule({
  declarations: [Y2021Component],
  imports: [
    CommonModule,
    Y2021RoutingModule,
    EventSharedModule
  ],
  exports: [
    Y2021Component
  ]
})
export class Y2021Module { }
